import { BFormTextarea } from './form-textarea';
import { pluginFactory } from '../../utils/plugins';
var FormTextareaPlugin = /*#__PURE__*/pluginFactory({
  components: {
    BFormTextarea: BFormTextarea,
    BTextarea: BFormTextarea
  }
});
export { FormTextareaPlugin, BFormTextarea };


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/components/form-textarea/index.js
// module id = 345
// module chunks = 44